<template>
  <WsCreate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :customCreateAction="customCreateAction"
    :staticModelData="staticModelData"
    titleKey="name"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/organization_role";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    staticModelData: (modelData, fields) => {
      let scopeFields = [
        "dashboard",
        "broadcast",
        "factories",
        "user",
        "role",
        "sos_request",
      ];
      scopeFields.forEach((scopeItem) => {
        if (fields[scopeItem].items.length) {
          fields[scopeItem].items.forEach((valueItem) => {
            let result = true;
            if (valueItem.value) {
              valueItem.value.forEach((item) => {
                if (result) {
                  result = modelData.scopes.includes(item);
                }
              });
              if (result) {
                modelData[scopeItem] = [
                  ...(modelData[scopeItem] || []),
                  ...valueItem.value,
                ];
              }
            }
          });
        }
      });
    },
    customCreateAction: (modelData) => {
      modelData.scopes = [];
      let scopeFields = [
        "dashboard",
        "broadcast",
        "factories",
        "user",
        "role",
        "sos_request",
      ];
      scopeFields.forEach((scopeItem) => {
        if (modelData[scopeItem] !== null&& modelData[scopeItem] !== undefined) {
          modelData.scopes.push(...modelData[scopeItem]);
        }
      });
      if (modelData.is_default !== undefined) {
        if (modelData.is_default === true) {
          modelData.is_default = 1
        } else if(modelData.is_default === false) {
          modelData.is_default = 0
        }
      }
      if (modelData.is_active !== undefined) {
        if (modelData.is_active === true) {
          modelData.is_active = 1
        } else if(modelData.is_active === false) {
          modelData.is_active = 0
        }
      }
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "角色資訊",
              fields: ["locales", "sequence"],
            },
            {
              title: "角色權限",
              fields: [
                "dashboard",
                "broadcast",
                "factories",
                "user",
                "role",
                "sos_request",
              ],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "客製角色",
              remark: "",
              fields: ["is_default", "organizations"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "顯示設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["is_active"],
            },
          ],
        },
      ],
    },
  }),
};
</script>